import { render, staticRenderFns } from "./RegistroViajerosAgencia.vue?vue&type=template&id=045f42db&scoped=true"
import script from "./RegistroViajerosAgencia.vue?vue&type=script&lang=js"
export * from "./RegistroViajerosAgencia.vue?vue&type=script&lang=js"
import style0 from "./RegistroViajerosAgencia.vue?vue&type=style&index=0&id=045f42db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f42db",
  null
  
)

export default component.exports